export const MIN_FILL_MS = 4000;
export const MAX_FILL_AGE_MS = 24 * 60 * 60 * 1000;

const MAX_FUTURE_SKEW_MS = 15 * 1000;
const MIN_MESSAGE_CHARS = 12;

export function honeypotTripped(website) {
    return String(website ?? '').trim() !== '';
}

export function devopsSubmitTooFast(rawLoadedAt, nowMs = Date.now()) {
    if (rawLoadedAt === undefined || rawLoadedAt === null || String(rawLoadedAt).trim() === '') {
        return 'form_loaded_at is required';
    }
    const loadedAt = Number(rawLoadedAt);
    if (!Number.isFinite(loadedAt)) {
        return 'form_loaded_at is required';
    }
    if (loadedAt > nowMs + MAX_FUTURE_SKEW_MS) {
        return 'form_loaded_at is invalid';
    }
    const elapsed = nowMs - loadedAt;
    if (elapsed < MIN_FILL_MS) {
        return 'form submitted too quickly';
    }
    if (elapsed > MAX_FILL_AGE_MS) {
        return 'form_loaded_at is invalid';
    }
    return '';
}

function normalizeSpamText(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function wordCount(message) {
    const words = message.match(/[\p{L}\p{N}]+/gu);
    return words ? words.length : 0;
}

function isOnlyLink(message) {
    const stripped = message
        .replace(/https?:\/\/\S+/gi, ' ')
        .replace(/\bwww\.\S+/gi, ' ')
        .replace(/[\s.,;:!?()[\]"'«»]+/g, '');
    return stripped.length === 0 && /(https?:\/\/|\bwww\.)/i.test(message);
}

export function leadMessageJunk(name, organization, message) {
    const text = String(message || '').trim();
    const normalized = normalizeSpamText(text);
    const sameName = normalizeSpamText(name);
    if (sameName.length > 0 && sameName === normalizeSpamText(organization) && sameName === normalized) {
        return 'message repeats the name and company';
    }
    if (isOnlyLink(text)) {
        return 'message must describe the problem, not only a link';
    }
    if (text.length < MIN_MESSAGE_CHARS || wordCount(text) < 2) {
        return 'message is too short';
    }
    return '';
}
